import { useEventListener } from './useEventListener.js';
export function useWindowEventListener(type, listener, options) {
    if (typeof window !== 'undefined') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEventListener(window, type, listener, options);
    }
}
//# sourceMappingURL=useWindowEventListener.js.map